<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <!-- SMALL loader for form content -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="form-row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="tax-year"><b>Tax Year<sup>*</sup>:</b></label>
              <select class="form-control" 
                      id="tax-year" 
                      name="tax-year" 
                      [(ngModel)]="selectedTaxYear"
                      (ngModelChange)="changeTaxYear()">
                @for (taxYear of taxYears; track $index) {
<option [value]="taxYear.label">
                  {{taxYear.label}}
                </option>
}
              </select>
            </div>
            @if (scenarioEntity.TAX_YEAR_NOT_VALID && !scenarioEntity.TAX_YEAR) {
<small class="text-danger" 
                  >
              Please provide Tax Year
            </small>
}
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="jcd-key"><b>JCD Key<sup>*</sup>:</b></label>
              <select class="form-control" 
                      id="jcd-key" 
                      name="jcd-key" 
                      [(ngModel)]="selectedJcdKey"
                      (ngModelChange)="changeJCDKey()">
                @for (jcdKey of jcdKeyList; track $index) {
<option [value]="jcdKey">
                  {{jcdKey}}
                </option>
}
              </select>
            </div>
            @if (scenarioEntity.JCD_KEY_NOT_VALID && !scenarioEntity.JCD_KEY) {
<small class="text-danger" 
                  >
              Please provide JCD Key
            </small>
}
          </div>

          <div class="col-md-4">
            <label for="scenario-type"><b>Scenario Type Code<sup>*</sup>:</b></label>
            <input type="text" 
                   class="form-control" 
                   id="scenario-type" 
                   name="scenario-type" 
                   placeholder="" 
                   [(ngModel)]="scenarioEntity.SCENARIO_TYPE_CODE"
                   (ngModelChange)="scenarioEntity.SCENARIO_TYPE_CODE_NOT_VALID = false">
            @if (scenarioEntity.SCENARIO_TYPE_CODE_NOT_VALID && !scenarioEntity.SCENARIO_TYPE_CODE) {
<small class="text-danger" 
                  >
              Please provide Scenario Type Code
            </small>
}
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-3">
            <label for="scenario-jurisdiction"><b>Scenario Jurisdiction<sup>*</sup>:</b></label>
            <input type="text" 
                   class="form-control" 
                   id="scenario-jurisdiction" 
                   name="scenario-jurisdiction" 
                   placeholder="" 
                   [(ngModel)]="scenarioEntity.SCENARIO_JURISDICTION"
                   (ngModelChange)="scenarioEntity.SCENARIO_JURISDICTION_NOT_VALID = false">
            @if (scenarioEntity.SCENARIO_JURISDICTION_NOT_VALID && !scenarioEntity.SCENARIO_JURISDICTION) {
<small class="text-danger" 
                  >
              Please provide Scenario Jurisdiction
            </small>
}
          </div>

          <div class="col-md-3">
            <label for="scenario-desc"><b>Scenario Description<sup>*</sup>:</b></label>
            <input type="text" 
                   class="form-control" 
                   id="scenario-desc" 
                   name="scenario-desc" 
                   placeholder="" 
                   [(ngModel)]="scenarioEntity.SCENARIO_DESC"
                   (ngModelChange)="scenarioEntity.SCENARIO_DESC_NOT_VALID = false">
            @if (scenarioEntity.SCENARIO_DESC_NOT_VALID && !scenarioEntity.SCENARIO_DESC) {
<small class="text-danger" 
                  >
              Please provide Scenario Description
            </small>
}
          </div>

          <div class="col-md-3">
            <label for="fed-scenario"><b>Fed Scenario:</b></label>
            <input type="text" 
                   class="form-control" 
                   id="fed-scenario" 
                   name="fed-scenario" 
                   placeholder="" 
                   [(ngModel)]="scenarioEntity.FED_SCENARIO">
          </div>

          <div class="col-md-3">
            <label for="fed-jcd"><b>Fed JCD Key:</b></label>
            <input type="text" 
                   class="form-control" 
                   id="fed-jcd" 
                   name="fed-jcd" 
                   placeholder="" 
                   [(ngModel)]="scenarioEntity.FED_JCD_KEY">
          </div>
        </div>
      </div>
    </div>
  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>

